function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M168 82.67c0 2.288-.164 4.54-.482 6.745-.734-2.008-2.271-3.69-4.368-4.498-1.714-.66-4.513-.627-6.11-.036-.757-6.71-2.5-13.013-5.05-18.655C151.573 66.398 137.814 72 116 72c-20.742 0-34.202-5.065-35.833-5.71-2.587 5.832-4.308 12.37-4.968 19.33a7.221 7.221 0 00-6.349-.559c-2.083.803-3.613 2.468-4.353 4.457A47.26 47.26 0 0164 82.672V57.444C64 38.974 79.784 24 99.254 24h33.492C152.216 24 168 38.973 168 57.444V82.67zm-12.93 28.666c1.201.055 2.527-.194 3.774-.702a50.191 50.191 0 01-5.826 6.68 51.565 51.565 0 002.052-5.978zm-77.37-.318a59.912 59.912 0 002.784 7.684 50.475 50.475 0 01-7.034-7.669 7.18 7.18 0 004.25-.015z",
  fill: "#DA242F"
});

function SvgHair64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/hair-6-4.2936198a.svg";
export { SvgHair64 as ReactComponent };